import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ErrorSeverityEnum } from '../models/error-severity-enum.model';

@Injectable()
export class MessageService {
  private httpErrorMessages: any[] = [];
  private messageToShow = new Subject<any>();

  /**
 * Método responsável por verificar e exibir a mensagem que deseja para o usuário.
 * @param message Mensagem como Objeto de configuração do Swal com o title, text e outras configurações da mensagem que deseja exibir.
 * Pode receber mensagens de dois tipos:
 * @class ErrorMessageModel: Caso inclua o errorSeverity ele irá decidir se mostrará swal, ou toast;
 * @class MessageModel: Irá tratar sempre como swal, e deve ser enviado o objeto de configuração completo
 * @example { title: 'Titulo teste', text: 'Erro desconhecido',  icon: 'warning' }
 */
  public handleMessage(message: any) {
    // Caso seja do tipo ErroMessageModel
    if (message && message.errorSeverity && message.errorSeverity === ErrorSeverityEnum.Low) {
      message.toast = true;
    }
    this.notifyMessage(message);
  }

  private notifyMessage(message: any) {
    this.messageToShow.next(<any>this.buildSwalOptions(message));
  }

  /**
   * Método responsável por ler a lista de erros no Storage, e trata-las de acordo com suas configurações, sendo utilizada apenas no handler de HTTP.
   */
  public triggerMessages() {
    this.getErrorVault();
    // Valida e executa as ações para cada ErrorMessage
    this.httpErrorMessages.forEach(error => {
      if (!error.alreadySended) {
        if (error.isThreatedError) {
          error.icon = 'warning';
         } else {
          error.icon = 'error';
         }
        if (error.showToUser) {
          this.handleMessage(error);
        }
        error.alreadySended = true;
        
      }
    });
    this.setErrorVault();
  }

  /**
 * Adiciona um objeto de erro na lista de erros no Storage a ser tratados posteriormente.
 */
  public addErrorToVault(error: any) {
    if (error) {
      this.getErrorVault();
      if (!this.httpErrorMessages) {
        this.httpErrorMessages = [];
      }
      this.httpErrorMessages.push(error);
      this.setErrorVault();
    }
  }

  private setErrorVault() {
    sessionStorage.setItem('errorVault', JSON.stringify(this.httpErrorMessages));
  }

  private getErrorVault() {
    this.httpErrorMessages = JSON.parse(sessionStorage.getItem('errorVault'));
  }

  /**
* Método responsável por retornar um Observable para controle do componente de envio de mensagens.
*/
  public get messagesToShow(): Observable<any> {
    return this.messageToShow.asObservable();
  }

  private buildSwalOptions(message: any) {
    return {
      title: message.title ? message.title : 'Ocorreu um erro!',
      text: message.text ? message.text : 'Erro não tratado, verifique com o suporte.',
      icon: message.icon ? message.icon : 'error',
      toast: message.toast ? message.toast : false,
      position: message.toast ? 'bottom-end' : 'center',
      showConfirmButton: message.toast ? message.showConfirmButton : true,
      timer: message.toast ? 3000 : 0,
      allowOutsideClick: false
    };
  }
}

